am4core.useTheme(am4themes_animated);

angular.module('app')
    .directive("barsamchart", ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
        return {
            restrict: "E",
            scope: {
                data: '=',
            },
            template: "<div id='chartdiv'></div>",
            replace: true,
            link: function ($scope) {
                var chart = am4core.create("chartdiv", am4charts.XYChart);

                setLang($rootScope.LANG)

                chart.paddingRight = 20;

                chart.data = [];

                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.baseInterval = {
                    "timeUnit": "day",
                    "count": 1
                }
                chart.dateFormatter.inputDateFormat = 'i';
                dateAxis.renderer.grid.template.location = 0;
                dateAxis.tooltipDateFormat = "d MMMM yyyy";
                chart.dateFormatter.dateFormat = "d MMMM yyyy, HH:mm";

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                var series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "delivery_cost";
                series.dataFields.dateX = "delivery_datetime";
                series.columns.template.tooltipText = "{dateX}: [bold]{valueY}[/]";
                series.columns.template.fillOpacity = .3;

                var columnTemplate = series.columns.template;
                columnTemplate.strokeWidth = 2;
                columnTemplate.strokeOpacity = .75;

                // Create scrollbars
                chart.scrollbarX = new am4core.Scrollbar();
                chart.scrollbarY = new am4core.Scrollbar();

                // chart.guides = new am4charts.XYCursor();
                chart.cursor = new am4charts.XYCursor();


                $scope.$watch('data', function (newData) {
                    $scope.render(newData);
                }, true);
                $scope.render = function (data) {

                    if (!data) {
                        return;
                    }
                    chart.data = data;

                }

                function setLang(lang) {
                    switch (lang) {
                        case 'en':
                            chart.language.locale = window.am4lang_en_US;
                            break;
                        case 'uk':
                            chart.language.locale = window.am4lang_uk_UA;
                            break;
                        case 'ru':
                            chart.language.locale = window.am4lang_ru_RU;
                            break;
                        case 'pl':
                            chart.language.locale = window.am4lang_pl_PL;
                            break;
                        case 'sk':
                            // todo добавить переводы
                            chart.language.locale = window.am4lang_en_US;
                            break;
                        case 'de':
                            chart.language.locale = window.am4lang_de_DE;
                            break;
                    }
                }

                $scope.$on("$destroy", function () {
                    chart.dispose();
                });

                $rootScope.$watch('LANG', function (newValue, oldValue) {
                    setLang(newValue);
                    $scope.render($scope.data);
                });
            }
        };
    }]);

